import React, {useState, useEffect, useRef} from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {QRCodeSVG} from 'qrcode.react';
export default function ModalQr(props) {
  return (
    <div className="row">
      <div className="col-12 col-md-9">
        <Tabs
          id="controlled-tab-example"
          activeKey={'plan'}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="plan" title="QR code">
            <div className="col-md-3 col-12 text-center">
              <div className="mb-2"></div>
              {props.item ? (
                <>
                  {props.item.planid}
                  <QRCodeSVG
                    value={props.item ? props.item.planid : 'nodata'}
                    size={240}
                  />
                </>
              ) : (
                <></>
              )}
              <div className="mb-0">
                {props.item ? props.item.date_start : ''}
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
